import Box from '@mui/material/Box';
import type { ReactNode } from 'react';
import type { MemberRow } from './types.js';

interface MemberStatusBadgeProps {
  status: MemberRow['status'];
}

export function MemberStatusBadge({ status }: MemberStatusBadgeProps): ReactNode {
  const isActive = status === 'active';

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        fontSize: 11,
        fontWeight: 700,
        py: 1,
        px: 2,
        borderRadius: 5,
        bgcolor: isActive ? 'success.bg' : 'warning.bg',
        color: isActive ? 'success.dark' : 'warning.dark',
      }}
    >
      {isActive ? (
        <Box
          component="span"
          sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: 'success.main' }}
        />
      ) : null}
      {isActive ? 'Active' : 'Invited'}
    </Box>
  );
}
